module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"action.login":"Se connecter","title.not.authenticated":"Veuillez-vous authentifier pour accèder à l\u0027application.","no.cabinet.selected":"Vous devez être affilié à un cabinet pour continuer à utiliser cette application. Si vous n\u0027avez pas la possibilité de choisir, veuillez contacter le support.","title.authenticating":"Authentification en cours veuillez patienter."}}')
  delete Component.options._Ctor
}
